import { ParsedMathJax } from '../../pages/components/ParsedMathJax';
import { ApiResponse, PatchDocumentFromJSON, PersonApi } from '../../api/core';
import * as React from 'react';
import { NavigateFunction } from 'react-router';
import { IntlShape } from 'react-intl';
import { ToastContextType } from '../providers/ToastProvider';

export const requestDeletePerson = (personApi: PersonApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, personId: number, personTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message: <ParsedMathJax content={intl.formatMessage({id: 'person.deleteRequest.popup.message'}, {personTitle})} />,
    header: intl.formatMessage({id: 'user.profile.publist.popup.delete.headline'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        await personApi.updatePerson({
          personId,
          patchDocument: [
            PatchDocumentFromJSON({
              op: 'replace',
              path: '/adminDataPerson/editorialStatus',
              value: 'deleted',
            }),
          ],
        });
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletionRequest.success.title'}),
          detail: intl.formatMessage({id: 'message.deletionRequest.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/persons');
      } catch (e) {
        console.error('Deletion request: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletionRequest.failed.title'}),
          message: intl.formatMessage({id: 'message.deletionRequest.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};

export const deletePerson = (personApi: PersonApi, toast: ToastContextType, intl: IntlShape, navigate: NavigateFunction, personId: number, personTitle: string, redirectPath?: string): void => {
  toast.confirm({
    message:
      <div>
        <p>{intl.formatMessage({id: 'person.delete.popup.message'})}</p>
        <p><strong><ParsedMathJax content={personTitle} /> (ID: {personId})</strong></p>
      </div>,
    header: intl.formatMessage({id: 'person.delete.popup.label'}),
    icon: 'pi pi-info-circle',
    defaultFocus: 'reject',
    acceptClassName: 'p-button-danger',
    acceptLabel: intl.formatMessage({id: 'button.confirm'}),
    accept: async (): Promise<void> => {
      try {
        const response: ApiResponse<void> = await personApi.deletePersonRaw({personId});
        if (!response.raw.ok) {
          throw new Error(response.raw.statusText);
        }
        toast.notify({
          summary: intl.formatMessage({id: 'message.deletion.success.title'}),
          detail: intl.formatMessage({id: 'message.deletion.success.message'}),
          severity: 'success',
        });
        void navigate(redirectPath || '/search/persons');
      } catch (e) {
        console.error('Delete failed: ', e);
        toast.alert({
          header: intl.formatMessage({id: 'message.deletion.failed.title'}),
          message: intl.formatMessage({id: 'message.deletion.failed.message'}),
        });
      }

    },
    rejectLabel: intl.formatMessage({id: 'button.abort'}),
  });
};
